import { gql } from '@apollo/client';

export const FETCH_SIGN_NOW_DOCUMENT_GROUP_FOR_ENROLLMENT = gql`
  query Flex_FetchSignNowDocumentGroupForEnrollment($planId: Int!) {
    signNowDocumentGroupByPlan(planId: $planId) {
      id
      status
      signingUrl
      userId
      inviteExpiresAt
      envelopeIds
    }
  }
`;

export const FETCH_SIGN_NOW_DOCUMENT_GROUP_STATUS = gql`
  mutation Flex_FetchSignNowDocumentGroupStatus($id: Int!) {
    fetchSignNowDocumentGroupStatus(id: $id) {
      id
      status
      signingUrl
      userId
      inviteExpiresAt
      envelopeIds
    }
  }
`;
